<template>
  <div class="container container-fluid card my-4">
    <div class="container">
      <!-- Componente Principal -->
      <transition name="slide-fade">
        <div v-if="mostrarComponentPrincipal" :key="1">
          <DataMain
            @datosPrincipales="updateDatosPrincipalesComponentes"
          />
        </div>
      </transition>

      <div>
        <button
          v-if="datosPrincipales.logo && !hayFormulario1"
          @click="onNewForm1('FormCreateCompanyPrimary')"
          class="btn btn-secondary mt-4"
        >
        Agregar Formulario
        </button>
      </div>

      <ul class="nav nav-tabs">
        <div v-if="mostrarForm1">
          <li class="nav-item">
            <button
              class="nav-link"
              :class="{ 'active': componentForm === 'FormCreateCompanyPrimary' }"
              @click="showComponent('FormCreateCompanyPrimary')"
            > 
            <div class="tab-content">
              <span>Formulario 1</span>
            </div>
            </button>
          </li>

        </div>
        <div v-if="hayFormulario1 && !hayFormulario2">
          <li class="nav-item">
            <button
              title="Crear otro Formulario"
              class="nav-link"
              @click="onNewForm2('FormCreateCompanySecondary')"
            > 
            <span> + </span>
          </button>
          </li>
        </div>
        <div v-if="mostrarForm2">
          <li class="nav-item">
            <button
              class="nav-link"
              :class="{ 'active': componentForm === 'FormCreateCompanySecondary' }"
              @click.prevent="onNewForm2('FormCreateCompanySecondary')"
            > 
            <div class="tab-content">
              <span>Formulario 2</span>
              <span @click.stop="eliminarFormulario('FormCreateCompanySecondary')" class="btn-close" aria-label="Cerrar"></span>
            </div>
            </button>
          </li>
        </div>
        <div v-if="hayFormulario2 && !hayFormulario3">
          <li class="nav-item">
            <button
              title="Crear otro Formulario"
              class="nav-link"
              @click="onNewForm3('FormCreateCompanyTertiary')"
            > 
            <span> + </span>
          </button>
          </li>
        </div>
        <div v-if="mostrarForm3">
          <li class="nav-item">
            <button
              class="nav-link"
              :class="{ 'active': componentForm === 'FormCreateCompanyTertiary' }"
              @click="showComponent('FormCreateCompanyTertiary')"
            > 
            <div class="tab-content">
              <span>Formulario 3</span>
              <span @click.stop="eliminarFormulario('FormCreateCompanyTertiary')" class="btn-close" aria-label="Cerrar"></span>
            </div>
            </button>
          </li>
        </div>
      </ul>

      <!-- Componentes Secundarios - Formulario 1 -->
      <div v-show="mostrarForm1 && (componentForm === 'FormCreateCompanyPrimary' || !hayFormulario1)">
        <FormCreateCompanyPrimary
          @formData1="updateDatosForm1"
        />
      </div>
      <!-- Componentes Secundarios - Formulario 2 -->
      <div v-show="mostrarForm2 && (componentForm === 'FormCreateCompanySecondary' || !hayFormulario2)">
        <FormCreateCompanySecondary
          @formData2="updateDatosForm2"
        />
      </div>
      <!-- Componentes Secundarios - Formulario 3 -->
      <div v-show="mostrarForm3 && (componentForm === 'FormCreateCompanyTertiary' || !hayFormulario3)">
        <FormCreateCompanyTertiary
          @formData3="updateDatosForm3"
        />
      </div>

      <div class="form-group d-grid gap-2 my-3">
        <button v-if="hayFormulario1 && mostrarGuardar" @click="saveFormData" class="btn btn-block btn-custom">
          Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import apiAdmin from '../../apis/Admin';
import DataMain from '../companies/create/DataMain';
import FormCreateCompanyPrimary from './create/FormCreateCompanyPrimary';
import FormCreateCompanySecondary from './create/FormCreateCompanySecondary';
import FormCreateCompanyTertiary from './create/FormCreateCompanyTertiary';

import { sharedState } from '../../Utils/StoreAsignacion';
import { handleError, handleSweetInfo } from '../../Utils/StatusHandler';
import { showSpinner, closeSpinner } from '../../Utils/AlertHandler';

export default {
  name: 'CreateCompany',
  components: {
    DataMain,
    FormCreateCompanyPrimary,
    FormCreateCompanySecondary,
    FormCreateCompanyTertiary
  },
  setup() {
    const mostrarComponentPrincipal = ref(sharedState.mostrarComponentPrincipal.value);
    const componentForm = ref(false);
    const mostrarForm1 = ref(false);
    const mostrarForm2 = ref(false);
    const mostrarForm3 = ref(false);
    const mostrarGuardar = ref(false);
    const datosPrincipales = ref([]);
    const datosSecundariosForm1 = ref([]);
    const datosSecundariosForm2 = ref([]);
    const datosSecundariosForm3 = ref([]);
    const errors = ref([]);
    const alert = ref([]);
    const companyName = ref(null);
    const emails = ref(null);
    const optionalEmails = ref([]);
    const logo = ref(null);

    const hayFormulario1 = ref(false);
    const hayFormulario2 = ref(false);
    const hayFormulario3 = ref(false);

    const handleErrors = (error) => {
      handleError(error, { errors });
    };

    const handleSweetAlert = (info) => {
      handleSweetInfo(info, { alert });
    };

    const showComponent = (component) => {
      componentForm.value = component;
    }

    const updateDatosPrincipalesComponentes = (dataMain) => {
      datosPrincipales.value = dataMain;
      emails.value = dataMain.email;
    };

    const updateDatosForm1 = (dataForm) => {
      datosSecundariosForm1.value = dataForm.formData;
      mostrarGuardar.value = datosSecundariosForm1.value.formName.length >= 6;
    };

    const updateDatosForm2 = (dataForm) => {
      datosSecundariosForm2.value = dataForm.formData;
    };

    const updateDatosForm3 = (dataForm) => {
      datosSecundariosForm3.value = dataForm.formData;
    };

    const saveFormData = async () => {
      try {
        showSpinner();
        const optionalEmailsArray = Array.isArray(datosPrincipales.value.optionalEmails)
        ? datosPrincipales.value.optionalEmails
        : [];
        const allEmails = [emails.value, ...optionalEmailsArray];
        
        const formData = new FormData();
        formData.append('name', datosPrincipales.value.name);
        formData.append('emails', allEmails);
        formData.append('images', datosPrincipales.value.logo);
        // console.log('datosPrincipales.value.logo',datosPrincipales.value.logo)

        if (hayFormulario1.value) {
          const formData1 = datosSecundariosForm1.value;
          formData.append('formulario1', JSON.stringify(formData1));
        }

        if (hayFormulario2.value) {
          const formData2 = datosSecundariosForm2.value;
          formData.append('formulario2', JSON.stringify(formData2));
        }

        if (hayFormulario3.value) {
          const formData3 = datosSecundariosForm3.value;
          formData.append('formulario3', JSON.stringify(formData3));
        }

        const response = await apiAdmin.posCreateCompany(formData);

        if (response) {
          closeSpinner();
          handleSweetAlert(response);
        }
      } catch (error) {
        console.error(error);
        closeSpinner();
        handleErrors(error);
      }
    };

    const onNewForm1 = (newComponent) => {
      hayFormulario1.value = true;
      componentForm.value = newComponent;
      mostrarForm1.value = true;
    };

    const onNewForm2 = (newComponent) => {
      hayFormulario2.value = true;
      componentForm.value = newComponent;
      mostrarForm2.value = true;
    };

    const onNewForm3 = (newComponent) => {
      hayFormulario3.value = true;
      componentForm.value = newComponent;
      mostrarForm3.value = true;
    };

    const eliminarFormulario = (componentForm) => {
      if (formularios[componentForm]) {
        formularios[componentForm].mostrar.value = false;
        formularios[componentForm].hay.value = false;
      }
    };

    const formularios = {
      'FormCreateCompanySecondary': { mostrar: mostrarForm2, hay: hayFormulario2 },
      'FormCreateCompanyTertiary': { mostrar: mostrarForm3, hay: hayFormulario3 }
    };

    onMounted(() => {
      mostrarComponentPrincipal.value = true;
    });

    return {
      mostrarComponentPrincipal,
      componentForm,
      mostrarForm1,
      mostrarForm2,
      mostrarForm3,
      mostrarGuardar,
      errors,
      alert,

      datosPrincipales,
      datosSecundariosForm1,
      datosSecundariosForm2,
      datosSecundariosForm3,

      companyName,
      emails,
      optionalEmails,
      logo,

      hayFormulario1,
      hayFormulario2,
      hayFormulario3,

      onNewForm1,
      onNewForm2,
      onNewForm3,
      eliminarFormulario,
      updateDatosPrincipalesComponentes,
      updateDatosForm1,
      updateDatosForm2,
      updateDatosForm3,
      saveFormData,
      showComponent
    };
  }
};
</script>
